// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container{bottom:0;bottom:env(safe-area-inset-bottom);left:0;left:env(safe-area-inset-left);min-height:48px;position:fixed;right:0;right:env(safe-area-inset-right)}.toolbar-content{font-size:16px!important;padding-left:16px}.v-input{margin-bottom:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
